/**
 * A status pill on the operator and dispatch screens (Operator.scss
 * `.pp-op-pill`). `tone` is one of ok | warn | bad | info | muted — the
 * tones operatorFormat's and dispatcherFormat's readings return.
 */
import React from 'react';

export default function Pill({ tone, children }) {
  return <span className={`pp-op-pill pp-op-pill--${tone}`}>{children}</span>;
}
